//Mixins
import { browserIdentifierMixins } from "@/app/mixins/utils/browser-identifier mixins.js";

export default {
    name: "LandingPagePrivacyPolicy",
    mixins: [browserIdentifierMixins],
    data(){
        return {
            tableOfContents: [
                {
                    text: "Privacy and Consumer Policy",
                    link: "#privacy-consumer-policy",
                    children: [
                        {
                            text: "Collecting Data",
                            link: "#collecting-data",
                        },
                        {
                            text: "How We Use This Data",
                            link: "#how-we-use-this-data",
                        },
                        {
                            text: "Consent to Use Information",
                            link: "#consent-to-use-information",
                        },
                    ],
                },
                {
                    text: "Consumer Policy",
                    link: "#consumer-policy",
                    children: [
                        {
                            text: "Usage",
                            link: "#usage",
                        },
                        {
                            text: "Functionality",
                            link: "#functionality",
                        },
                        {
                            text: "Membership",
                            link: "#membership",
                        },
                        {
                            text: "Orders",
                            link: "#orders",
                        },
                        {
                            text: "Intellectual Property",
                            link: "#intellectual-property",
                        },
                        {
                            text: "Privacy and Personal Information",
                            link: "#privacy-and-personal-information",
                        },
                        {
                            text: "Typographical Errors",
                            link: "#typographical-errors",
                        },
                        {
                            text: "Content",
                            link: "#content",
                        },
                        {
                            text: "Third-Party Links",
                            link: "#third-party-links",
                        },
                        {
                            text: "Third-Party Information",
                            link: "#third-party-information",
                        },
                        {
                            text: "Consumer Guarantees",
                            link: "#consumer-guarantees",
                        },
                        {
                            text: "Limitation of Liability",
                            link: "#limitation-of-liability",
                        },
                        {
                            text: "Indemnity",
                            link: "#indemnity",
                        },
                    ],
                },
                {
                    text: "Dog Purchase",
                    link: "#dog-purchase-info",
                    children: [
                        {
                            text: "Preventable genetically Inherited traits or diseases",
                            link: "#preventable-events",
                        },
                        {
                            text: "Lost / Stolen / Death",
                            link: "#lost-stolen-death",
                        },
                    ],
                },
                {
                    text: "Responsible Dog Breeding Practices",
                    link: "#responsible-dog-breeding-practices",
                    children: [
                        {
                            text: "Introduction",
                            link: "#introduction",
                            descriptions: [
                                "Importance of responsible breeding",
                                "Ethical considerations",
                            ]
                        },
                        {
                            text: "Selecting Suitable Breeding Dogs",
                            link: "#selecting-suitable-breeding-dogs",
                            descriptions: [
                                "Evaluating genetic background and health history",
                                "Avoiding inbreeding and hereditary disorders",
                            ]
                        },
                        {
                            text: "Health and Genetic Testing",
                            link: "#health-and-genetic-testing",
                            descriptions: [
                                "Importance of veterinary checks",
                                "Recommended genetic tests for common breeds",
                            ]
                        },
                        {
                            text: "Proper Care and Well-being",
                            link: "#proper-care-and-well-being",
                            descriptions: [
                                "Providing quality food, clean water, and proper shelter",
                                "Ensuring regular exercise and socialization",
                                "Maintaining a clean and safe environment",
                            ]
                        },
                        {
                            text: "Responsible Breeding Practices",
                            link: "#responsible-breeding-practices",
                            descriptions: [
                                "Breeding age and frequency guidelines",
                                "Avoiding overbreeding and ensuring recovery time for bitches",
                                "Keeping detailed breeding records",
                            ]
                        },
                        {
                            text: "Ensuring Safe and Ethical Puppy Placement",
                            link: "#ensuring-safe-and-ethical-puppy-placement",
                            descriptions: [
                                "Screening potential buyers",
                                "Providing proper documentation and health records",
                                "Ensuring puppies are well-socialized before rehoming",
                            ]
                        },
                        {
                            text: "Educating the Public",
                            link: "#educating-the-public",
                            descriptions: [
                                "Informing buyers about responsible dog ownership",
                                "Providing resources and support for new owners",
                            ]
                        },
                        {
                            text: "Promoting Transparency and Accountability",
                            link: "#promoting-transparency-and-accountability",
                            descriptions: [
                                "Keeping open communication with buyers",
                                "Being transparent about breeding practices and health issues",
                            ]
                        },
                        {
                            text: "Legal and Regulatory Compliance",
                            link: "#legal-regulatory-compliance",
                            descriptions: [
                                "Understanding and adhering to local breeding laws and regulations",
                                "Obtaining necessary licenses and permits",
                            ]
                        },
                        {
                            text: "Conclusion",
                            link: "#conclusion",
                            descriptions: [
                                "Summary of key points",
                                "Encouragement to practice responsible breeding",
                            ]
                        },
                    ],
                },
                {
                    text: "Federal Laws",
                    link: "#federal-laws",
                    children: [],
                },
                {
                    text: "State and Territory Laws",
                    link: "#state-and-territory-laws",
                    children: [],
                },
                {
                    text: "Local Council Regulations",
                    link: "#local-council-regulations",
                    children: [],
                },
                {
                    text: "Key Requirements",
                    link: "#key-requirements",
                    children: [],
                },
                {
                    text: "Penalties for Non-Compliance",
                    link: "#penalties-for-non-compliance",
                    children: [],
                },
                {
                    text: "OCSEA Policy",
                    link: "#ocsea-policy",
                    children: [
                        {
                            text: "Zero Tolerance Policy",
                            link: "#zero-tolerance-policy",
                        },
                        {
                            text: "Prohibited Activities",
                            link: "#prohibited-activites",
                        },
                        {
                            text: "Reporting and Response",
                            link: "#reporting-and-response",
                        },
                        {
                            text: "Member Responsibilities",
                            link: "#member-responsibilities",
                        },
                        {
                            text: "Support and Resources",
                            link: "#support-and-resources",
                        },
                        {
                            text: "Legal Compliance",
                            link: "#legal-compliance",
                        },
                        {
                            text: "Enforcement",
                            link: "#enforcement",
                        },
                    ],
                },
            ],
        };
    },
    mounted() {
		window.addEventListener("scroll", this.scrollToTop)


        if (this.$route.hash) {
            if (this.checkBrowser() === "safari") {
                setTimeout(() => {
                    const element = document.querySelector(`${this.$route.hash}`);
                    this.scrollElementIntoView(element);
                }, 500);
            } else {
                setTimeout(() => {
                    const element = document.querySelector(`${this.$route.hash}`);
                    element.scrollIntoView({ behavior: "smooth" });
                }, 500);
            }
        }
    },
    destroyed() {
		window.removeEventListener("scroll", this.scrollToTop)
	},
    methods: {
        scrollElementIntoView(element) {
            const finalOffset = element.getBoundingClientRect().top;

            window.parent.scrollTo({
                top: finalOffset,
            });
        },
        scrollToTop() {
			const btnToTop = document.getElementById("btn-back-to-top")
            if(btnToTop){
                if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                    btnToTop.style.display = "flex"
                } else {
                    btnToTop.style.display = "none"
                }
            }
		},
        backToTop() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
    },
};
